module.exports = __webpack_public_path__ + "img/lectura.ea66b77c.svg";